import angular from "angular";
import { Configs } from "@salaxy/core";
/**
 * Controller for action button
 */
export class ActionButtonController implements angular.IController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = [];

  /** Text for the button */
  public label: string;

  /** Additional Bootstrap or custom style classes. I.e. btn-danger, btn-sm, my-btn. Defaults to btn-primary. */
  public buttonClass: string;

  /**
   * Action to be executed.
   * newCalc: starts a new blank calculation.
   * newCalcForEmployment: starts a new calculation for the given employment ID.
   * newPayroll: starts a new blank payroll.
   * newWorker: opens workerWizard for creating a new worker.
   * newMessage: starts a new message thread with partner.
   * payment: opens the payment dialog for the current calculation.
   * newTaxcard: Links to taxcards page. Currently supported only when role is Worker.
   * newRepair: starts a new repair process for a calculation.
   */
  public action: "newCalc" | "newCalcForEmployment" | "newPayroll" | "newWorker" | "newMessage" | "payment" | "newTaxcard" | "newRepair";

  /** Disabled but visible */
  public disabled?: boolean;

  /** Optional options for button. */
  public options?: {
    /**
     * id: id of current item such as Employment or Calculation. Currently used only in newCalcForEmployment action.
     */
    id: string,
  };

  /**
   * Function that is called after the function. This is typically used for navigation or a list reload.
   */
  public onAfterAction: () => Promise<void>;

  /**
   * Creates a new InputController
   * @ignore
   */
  constructor() {
    //
  }

  /**
   * Implement IController
   */
  public $onInit = () => {
    this.buttonClass = this.buttonClass || "btn-primary";
  };

  /**
   * Returns environment based on config.
   * TODO: Replace this with ConfigsLogic
   */
  public getEnv(): "local" | "test" | "demo" | "prod" | "rc" {
    const config = Configs.current;
    if (!config.isTestData) {
      return "prod";
    }
    if (config.apiServer?.indexOf("localhost") > -1  ) {
      return "local";
    }
    if (config.integrationsServer?.indexOf("test") > -1  ) {
      return "test";
    }
    if (config.apiServer?.indexOf("rc") > -1  ) {
      return "rc";
    }
    return "demo";
  }

}
